export default __webpack_public_path__ + "static/tranform_nlp-066478ef6f818953690e8df02e841597.webp";